import {LAST_READ_CHAT, NOTIFICATION_SSE} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {getAccountInfo} from "../utils/GenericUtils";
import {getConfig} from "./utils/ConfigUtils";

export function addNotificationSse(notifcation, dispatch) {
	dispatch({type: NOTIFICATION_SSE, payload: notifcation})
}

export function addLastReadChat(newLastRead, dispatch, who) {
	if (who) {
		console.log(who);
	}
	dispatch({type: LAST_READ_CHAT, payload: newLastRead})
}

export function updateChatController(newReadChat) {
	console.log("AGGIORNO CHAT CONTROLLER - " + JSON.stringify(newReadChat));
	axios
		.post("/atlantis-api-v1/API/auth/updateUserChatController", {
			username: getAccountInfo().username,
			chatController: JSON.stringify(newReadChat),
		}, getConfig())
		.then(() => {
		})
		.catch((error) => console.log(JSON.stringify(error)))
}
